import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

function InputField({
  label,
  value,
  onChange,
  required = false,
  fullWidth = true,
  icon: Icon,
  type = 'text',
  multiline = false,
  rows,
  placeholder,
  disabled = false,
  error = false,
  helperText,
  slotProps,
  ...rest
}) {
  const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      color: 'white',
      '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.2)' },
      '&:hover fieldset': { borderColor: '#F6911D' },
      '&.Mui-focused fieldset': { borderColor: '#F6911D' },
      '&.Mui-disabled': {
        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
      },
      '&.Mui-disabled input': {
        color: 'rgba(255, 255, 255, 0.4)',
        WebkitTextFillColor: 'rgba(255, 255, 255, 0.4)',
      },
      '&.Mui-disabled textarea': {
        color: 'rgba(255, 255, 255, 0.4)',
        WebkitTextFillColor: 'rgba(255, 255, 255, 0.4)',
      },
    },
    '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.6)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#F6911D' },
    '& .MuiFormHelperText-root': {
      color: '#ef4444',
    },
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      required={required}
      fullWidth={fullWidth}
      type={type}
      multiline={multiline}
      rows={rows}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      helperText={helperText}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          startAdornment: Icon ? (
            <InputAdornment position="start">
              <Icon sx={{ color: '#F6911D' }} />
            </InputAdornment>
          ) : (
            slotProps?.input?.startAdornment
          ),
        },
      }}
      sx={textFieldStyles}
      {...rest}
    />
  );
}

export default InputField;
